export default "__VITE_ASSET__CVZV$mr3__"